import type { AssistantSession } from '@stores/assistantSession'
import assistantStore from '@stores/assistantStore'
import { createContext, ReactNode, useContext } from 'react'

/**
 * The chat a panel shows. Nothing provides it for the drawer and the standalone page: they show
 * the drawer's session (assistantStore.drawer). An embedded placement provides its own session
 * (assistantStore.sessionFor), so its messages, draft and errors never mix with the drawer's.
 */
const AssistantSessionContext = createContext<AssistantSession | null>(null)

export const AssistantSessionProvider = ({
  session,
  children,
}: {
  session: AssistantSession
  children: ReactNode
}) => (
  <AssistantSessionContext.Provider value={session}>
    {children}
  </AssistantSessionContext.Provider>
)

/**
 * The session of the panel this component is in; the drawer's outside any provider. What the
 * user has app-wide (capabilities, the privacy notice, the conversation list, the guide pages,
 * the briefing, which view is shown) is still read from assistantStore.
 */
export const useAssistantSession = (): AssistantSession =>
  useContext(AssistantSessionContext) ?? assistantStore.drawer

export default AssistantSessionContext
